export default [
  {
    path: '/mockups/example',
    component: () => import('app/views/mockups/Example')
  },
  {
    name: 'mockups.site-links',
    path: '/mockups/site-links',
    component: () => import('app/views/mockups/SiteLinks')
  }
]
